function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
}, React.createElement("path", {
  d: "m14.23 2.94-2.17-2.17c-.36-.36-.94-.36-1.3 0l-4.77 4.83-.66 3.03c-.14.65.44 1.23 1.09 1.09l3.03-.66 4.78-4.83c.35-.36.35-.94 0-1.29z"
}), React.createElement("path", {
  d: "m12.49 9.24h-.41c-.55 0-1 .46-1 1.01v1.69h-8.16v-8.16h1.69c.56 0 1.01-.45 1.01-1.01v-.41c0-.55-.46-1-1.01-1h-3.1c-.5 0-.89.37-.98.85 0 .05-.03.1-.03.16v10.99c0 .26.11.49.27.67.01.01.02.03.03.04s.03.02.04.03c.18.16.41.27.67.27h10.98c.26 0 .49-.11.67-.27.01-.01.03-.02.04-.03s.02-.03.03-.04c.16-.18.27-.41.27-.67v-3.1c0-.56-.45-1.01-1.01-1.01z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 14.86"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/window-outlined.8e7d945a.svg";
export { SvgComponent as ReactComponent };